import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, IconButton, Stack } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { isAction } from '@reduxjs/toolkit';

const DynamicDeviceForm = ({label, value, handleChange, disabled}) => {
  const template = {name: '', url: ''};

  const color = disabled ? 'rgba(0, 0, 0, 0.38)' : '#000'
// helper to ensure each row has a stable unique id
//   const makeRow = (obj = {}) => {
//     const id = obj.id || (typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2,9)}`);
//     // preserve incoming values but fill missing keys from template
//     return { ...template, ...obj, id };
//   };

  // Initialize with one row. We add a 'key' for React's reconciliation.
  // const [rows, setRows] = useState(Array.isArray(value) && value.length > 0 ? value : [template]);
  const [rows, setRows] = useState(value);

//   const [rows, setRows] = useState(() => {
//     if (Array.isArray(value) && value.length > 0) {
//       return value.map(v => makeRow(v));
//     }
//     return [makeRow()];
//   });

  // APPEND: Add a new row based on the template
  const append = () => {
    // setRows([...rows, { ...template, id: crypto.randomUUID() }]);
    setRows([...rows ?? [], { ...template }]);
  };

  // DELETE: Remove by ID (safer than index)
  const remove = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
    // if (rows.length > 1) {
    //   setRows(rows.filter(row => row.id !== id));
    // }
  };

  // UPDATE: Change a specific field in a specific row
  const updateField = (index, field, value) => {
    const updatedRows = rows.map((item, i) => {
        if (i === index) {
            return { ...item, [field]: value };
        }
        return item;
    });
    setRows(updatedRows);
    handleChange(updatedRows);

    // setRows(rows.map(row => 
    //   row.id === id ? { ...row, [fieldName]: value } : row
    // ));
  };

  const handleSubmit = () => {
    // Strip the 'id' before sending to the API
    if (rows) {
        const result = rows.map(({ id, ...rest }) => rest);
        handleChange(result);
    } else {
        handleChange(null);
    }
  };

  useEffect(() => {
    // console.log('rows changed', rows);
    handleSubmit(rows ?? null);
  }, [rows]);

  useEffect(() => {
    // console.log('value prop changed', value);
    if (JSON.stringify(value) !== JSON.stringify(rows)) {
      setRows(value);
    }
  }, [value]);

  return (
    <Box sx={{ border: `1px solid ${color}`, color: color, padding: 2, borderRadius: 1 }}>
        <div style={{marginBottom: 10}}>{label}</div>
      <Stack spacing={2}>
        {rows && rows.map((row, index) => (
          <Box key={row + '-' + index} sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            {
                Object.keys(row).map((key, i) => {
                    const isId = key === 'id';
                    return (
                        <TextField
                            sx={{visibility: isId ? 'hidden' : 'visible', width: isId ? '0px' : 'auto', minWidth: '200px'} }
                            key={key + '-' + i}
                            label={key}
                            value={row[key] || ''}
                            onChange={(e) => updateField(index, key, e.target.value)}
                            size="small"
                            disabled={disabled}
                        />
                    )
                })
            }
            
            <IconButton onClick={() => remove(index)} color="error" disabled={disabled}>
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}
      </Stack>

      <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
        <Button startIcon={<AddIcon />} variant="outlined" onClick={append} disabled={disabled}>
          Add
        </Button>
      </Box>
    </Box>
  );
};

export default DynamicDeviceForm;